import { Storage } from "aws-amplify";
import awsConfig from "../aws-exports";

export default async (imagePreview) => {
  try {
    const S3Image =
      imagePreview && imagePreview.file
        ? await Storage.put(
            `${imagePreview.file.uid}-${imagePreview.file.name}`,
            imagePreview.file,
            {
              contentType: imagePreview.file.type,
              level: "public"
            }
          )
        : null;

    return {
      key: S3Image.key,
      bucket: awsConfig.aws_user_files_s3_bucket,
      region: awsConfig.aws_user_files_s3_bucket_region,
    };
  } catch (error) {}
};
